import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Building2, ChevronDown, ChevronUp, Eye, EyeOff } from 'lucide-react';

const DepartmentControls = ({
  activeDepartmentsCount,
  plannedDepartmentsCount,
  allDepartmentsCollapsed,
  editDepartmentMode,
  onToggleCollapse,
  onToggleEditMode
}) => {
  return (
    <div 
      className="flex items-center justify-between mb-3 p-2 bg-card border-2 border-primary/20 rounded-lg shrink-0" 
      style={{ boxShadow: '0 0 10px rgba(59, 130, 246, 0.15)' }}
    >
      <div className="flex items-center gap-3">
        <h2 className="font-semibold text-sm flex items-center gap-2">
          <Building2 className="h-4 w-4 text-primary" />
          Department Overview
        </h2>
        <Badge variant="outline" className="text-xs">
          {activeDepartmentsCount} Active · {plannedDepartmentsCount} Planned
        </Badge>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onToggleCollapse}
          className="text-xs"
        >
          {allDepartmentsCollapsed ? (
            <>
              <ChevronDown className="h-3 w-3 mr-1" />
              Expand All Departments
            </>
          ) : (
            <>
              <ChevronUp className="h-3 w-3 mr-1" />
              Collapse All Departments
            </>
          )}
        </Button>
        <Button
          variant={editDepartmentMode ? "default" : "outline"}
          size="sm"
          onClick={onToggleEditMode}
          className={`text-xs ${editDepartmentMode ? 'bg-amber-600 hover:bg-amber-700' : ''}`}
        >
          {editDepartmentMode ? (
            <>
              <EyeOff className="h-3 w-3 mr-1" />
              Exit Edit Mode
            </>
          ) : (
            <>
              <Eye className="h-3 w-3 mr-1" />
              Edit Department Visibility
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default DepartmentControls;